module.exports = "/src/views/player/help/images/lost2.jpg";